export default "/images/69d83c5ac1af35adef9c9d90c98b7f45.avif";